export const projectJoin = 'admin/app/projects/join';
export const projectGet = 'admin/app/projects/get';
export const projectMetadata = 'admin/app/projects/metadata';
export const projectsIncomplete = 'admin/app/projects/incomplete_list';
export const projectsInprocess = 'admin/app/projects/inprocess_list';
export const projectsLoaned = 'admin/app/projects/loaned_list';
export const projectsJoined = 'admin/app/projects/joined_list';
export const projectsBoard = 'admin/app/projects/board';
export const projectAvailableDocuments = 'admin/app/projects/available_documents';
export const projectGuarantor = 'admin/app/projects/guarantor';
export const projectLeave = 'admin/app/projects/leave';
export const projectsBorrowerHistory = 'admin/app/projects/rem_history';
export const projectRepaySchedule = 'admin/app/projects/get_repay_schedule';
export const projectSaleOrder = 'admin/app/projects/sale_order';
export const projectBuySaleOrder = 'admin/app/projects/buy_sale_order';
export const projectInvestSales = 'admin/app/projects/get_invest_sales';
export const projectsInvestFeed = 'admin/app/projects/invest_feed';
export const projectsInvestClose = 'admin/app/projects/close_sale_order';
export const projectsInvestHistory = 'admin/app/projects/get_resale_history';
export const projectsCalcPayment = 'admin/app/projects/calc_early_payment';
export const projectsCreateEarlyPayment = 'admin/app/projects/create_early_payment';
export const projectsCancelEarlyPayment = 'admin/app/projects/cancel_early_payment';
export const getBorrowerPortfolio = 'admin/app/projects/get_borrower_portfolio';
export const getBorrowerDebt = 'admin/app/projects/get_borrower_debt';
